'use strict';

// Constant Includes
var CONSTANTS = {
    CAROUSEL: require('../constants/carousel')
};

/**
 * Creates a customizable carousel element using Owl Carousel library.
 * @param {JQuery<HTMLElement> | string} $element - select element to use on Owl Carousel element build
 * @param {string} id - Object instance identifier. Useful to get object instance after page load.
 * @param {string} config - Configuration type option.
 */
function CarouselModel($element, id, config) {
    this.$element = $($element);
    this.id = id;
    this.config = config;
    this.$carousel = null;
}

/**
 * Initialize carousel based on $element.
 */
CarouselModel.prototype.setCarousel = function () {
    if (this.$element.length) {
        $(this.$element).owlCarousel(CONSTANTS.CAROUSEL[this.config.toUpperCase()]);

        // Ensure nav buttons are accessible after initialization
        setTimeout(function () {
            var $nav = $(this.$element).find('.owl-nav');
            if ($nav.length) {
                $nav.find('.owl-prev').each(function () {
                    var $btn = $(this);
                    $btn.removeAttr('role');
                    if (!$btn.attr('aria-label')) {
                        $btn.attr('aria-label', 'Previous');
                    }
                    $btn.find('span').not('.sr-only').attr('aria-hidden', 'true');
                });
                $nav.find('.owl-next').each(function () {
                    var $btn = $(this);
                    $btn.removeAttr('role');
                    if (!$btn.attr('aria-label')) {
                        $btn.attr('aria-label', 'Next');
                    }
                    $btn.find('span').not('.sr-only').attr('aria-hidden', 'true');
                });
            }
        }.bind(this), 50);
    }

    this.$carousel = this.$element;
};

module.exports = CarouselModel;
